import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PageInfoSalesOrderResultDTO,
  SalesOrderApiService,
  SalesOrderDTO,
  SalesOrderResultDTO,
  SalesOrderStatus,
} from '@app/api/purchase-service-sales';

export interface SalesOrderSearchParams {
  series?: string;
  vendorCode?: string;
  status?: SalesOrderStatus | null;
  /** PrimeNG lazy-table offset. */
  first: number;
  rows: number;
}

/** Wraps the purchase-service sales client for the dealer sales order screens. */
@Injectable({ providedIn: 'root' })
export class SalesOrderService {
  private readonly api = inject(SalesOrderApiService);

  search(params: SalesOrderSearchParams): Observable<PageInfoSalesOrderResultDTO> {
    return this.api.page({
      series: params.series?.trim() || undefined,
      vendorCode: params.vendorCode?.trim() || undefined,
      status: params.status ?? undefined,
      page: Math.floor(params.first / params.rows),
      size: params.rows,
      sortBy: 'id',
      ascending: false,
    });
  }

  getById(id: number): Observable<SalesOrderResultDTO> {
    return this.api.getDetail(id);
  }

  create(body: SalesOrderDTO): Observable<SalesOrderResultDTO> {
    return this.api.create(body);
  }

  approve(id: number): Observable<SalesOrderResultDTO> {
    return this.api.approve(id);
  }

  /** Release: one outbound delivery order is requested per warehouse. */
  release(id: number): Observable<SalesOrderResultDTO> {
    return this.api.release(id);
  }

  reject(id: number): Observable<SalesOrderResultDTO> {
    return this.api.updateStatus(id, 'REJECTED');
  }

  cancel(id: number): Observable<SalesOrderResultDTO> {
    return this.api.updateStatus(id, 'CANCELLED');
  }

  delete(id: number): Observable<SalesOrderResultDTO> {
    return this.api.delete(id);
  }
}
